import { makeStyles } from "tss-react/mui";
import { FONT_WEIGHTS } from "../../../theme/fontWeights";

export const useStyle = makeStyles()((theme) => ({
    container: {
        width: "100%",
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
    },
    icon: {
        width: 56,
    },
    email: {
        fontWeight: FONT_WEIGHTS.default,
    },
}));
